_ = require('lodash')

teeOfClubLabelFilter = (ScoreCardUIService) ->
  (input) ->
    return unless input
    option = _.find ScoreCardUIService.getDefaultData().teeOffClubOptions, (t) ->
      t.value is input

    option?.text

teeOfClubLabelFilter.$inject = [
  'ScoreCardUIService'
]

module.exports = teeOfClubLabelFilter



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/score-card/tee-of-club-filter.coffee